import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ComponentFactory from './Factory/ComponentFactory';
import ButtonComponent from './ButtonComponent';

const ContainerComponent = ({
  content,
  variant,
  bgColor,
  border,
  priorDecisions,
  formData,
  readOnly,
  updateFormData,
  handleButtonAction,
  isTouchDevice,
  isMouseDevice
}) => {
  return (
    <Box
      style={{
        width: `var(--${variant}-width)`,
        height: `var(--${variant}-height)`,
        padding: `var(--${variant}-padding)`,
        gap: `var(--${variant}-gap)`,
        borderRadius: `var(--${variant}-border-radius)`,
        border: border || `var(--${variant}-border)`,
        backgroundColor: bgColor || `var(--${variant}-bg-color, transparent)`,
        opacity: `var(--${variant}-opacity)`,
      }}
      mb={4}
    >
      {content.map((nestedItem, index) => {
        if (!readOnly && nestedItem.type === 'button' && Array.isArray(nestedItem.cta)) {
          const hasHalfVariant = nestedItem.cta.some(ctaItem => ctaItem.variant?.includes('-half'));
          const Wrapper = hasHalfVariant ? Flex : Box;
          const wrapperProps = hasHalfVariant ? { justify: "space-between", gap: 4, width: "100%" } : {};
          return (
            <Wrapper key={`btns-wrapper-${index}`} {...wrapperProps}>
              {nestedItem.cta.map((ctaItem, btnIndex) => (
                <ButtonComponent
                  key={`cta-${btnIndex}`}
                  action={ctaItem.action}
                  label={ctaItem.label}
                  ariaLabel={ctaItem.ariaLabel}
                  tooltip={ctaItem.tooltip}
                  variant={ctaItem.variant || 'solid'}
                  marginBottom='0px'
                  icons={ctaItem.icons}
                  onClick={() => handleButtonAction(ctaItem.action, ctaItem)}
                  textDecoration={ctaItem.textDecoration}
                  isDisabled={String(ctaItem.isDisabled).toLowerCase() === 'true'}
                  isTouchDevice={isTouchDevice}
                  isMouseDevice={isMouseDevice}
                />
              ))}
            </Wrapper>
          );
        }

        return (
          <ComponentFactory
            key={index}
            section={nestedItem}
            priorDecisions={priorDecisions}
            formData={formData}
            updateFormData={updateFormData}
            handleButtonAction={handleButtonAction}
          />
        );
      })}
    </Box>
  );
};

export default ContainerComponent;
